import { render, staticRenderFns } from "./DepartmentAssignSubDepart.vue?vue&type=template&id=7e10eef7&scoped=true"
import script from "./DepartmentAssignSubDepart.vue?vue&type=script&lang=js"
export * from "./DepartmentAssignSubDepart.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAssignSubDepart.vue?vue&type=style&index=0&id=7e10eef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e10eef7",
  null
  
)

export default component.exports